export default function guest({ next, router }) {
    const token = localStorage.getItem('access_token')
    const role = localStorage.getItem('user_role')
    if (token) {
        if (role == '"superadmin"') {
            return router.push({ name: 'Dashboard' });
        }
        else if(role == '"companyadmin"'){
            return router.push({ name: 'CompanyDashboard' });
        }
        else if(role == '"employee"'){
            return router.push({ name: 'employee-dashboard' });
        }
    }
    return next();
}
